import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { localize } from 'wanderu-i18n';

import chiku from 'wanderu-assets/images/chiku.svg';
import magnifyingGlass from 'wanderu-assets/images/magnifying-glass.svg';

import styles from './ChikuSearchAnimation.scss';

function ChikuSearchAnimation(props) {
    const {
        t,
        className,
    } = props;
    return (
        <div
            className={classNames(className, styles.chikuContainer)}
            role="presentation"
        >
            <div className={styles.animationContainer}>
                <img
                    alt={t('chiku')}
                    className={styles.chiku}
                    src={chiku}
                />
                <img
                    alt={t('magnifyingGlass')}
                    className={styles.magnifyingGlass}
                    src={magnifyingGlass}
                />
            </div>
            <span className={styles.subtext}>
                {t('find-best-deals')}
            </span>
        </div>
    );
}

ChikuSearchAnimation.propTypes = {
    className: PropTypes.string,
};

ChikuSearchAnimation.defaultProps = {
    className: '',
};

export { ChikuSearchAnimation };
export default localize(ChikuSearchAnimation, 'baseApp');
